<template>
  <div class="list-content">
    <direction />
    <div class="left" v-if="isInfo == 1">
      <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
        <el-tab-pane label="任务榜" name="1">
          <!-- <div class="header">
            <div
              class="title"
              @click="!ismoreRen ? (ismoreRen = true) : ''"
              :style="!ismoreRen ? 'cursor: pointer;' : ''"
            >
              <i v-if="!ismoreRen" class="el-icon-arrow-left"></i> 任务榜
            </div>
            <div class="more" v-if="ismoreRen" @click="ismoreRen = false">
          更多>>
        </div>
          </div> -->
          <div class="products">
            <div class="list" v-show="taskList.length != 0 && ismoreRen">
              <!-- @scroll="scrollTask" -->
              <div
                class="list-item"
                v-for="(item, index) in taskList"
                :key="item.id"
                @click="getTaskInfo(1, item)"
              >
                <div class="top">
                  <div class="index">{{ index + 1 }}</div>
                  <div class="title">{{ formatString(item.taskName) }}</div>
                  <div class="accept" @click.stop="getTaskInfo(2, item)">
                    立即接单
                  </div>
                </div>
                <div class="center">
                  <div class="type">
                    {{ item.practiceTypeName }}
                  </div>
                  <div class="region">
                    {{ item.practiceAddres }}
                  </div>
                  <div class="demand">
                    要求 : {{ formatString(item.taskRequire) }}
                  </div>
                  <div class="price">
                    <span class="unit">¥</span> {{ item.taskPrice }}
                  </div>
                </div>
                <div class="bottom">
                  <div class="createTime">{{ item.createTime }}</div>
                </div>
              </div>
            </div>
            <div
              class="list"
              v-show="taskList.length != 0 && !ismoreRen"
              @scroll="scrollTask"
            >
              <div class="sort_box1">
                <div class="">
                  <span
                    :style="{ color: sort_xz === 'time' ? '#f74d47' : '#333' }"
                    >时间</span
                  >
                  <img
                    v-show="sort_xz !== 'time'"
                    class="downward"
                    :src="wqUrl + 'aiExistingWritings_notSort.png'"
                    mode=""
                  />
                  <img
                    v-show="sort_xz === 'time'"
                    class="downward"
                    :src="wqUrl + 'aiExistingWritings_sort.png'"
                    mode=""
                  />
                </div>

                <div class="">
                  <span
                    :style="{ color: sort_xz === 'pase' ? '#326AFB' : '#333' }"
                    >价格</span
                  >
                  <img
                    style="width: 7px; height: 11px; margin-left: 7px"
                    v-if="sort_xz === 'pase'"
                    :src="wqUrl + sortImg[sortData.pase]"
                    mode=""
                  />
                  <img
                    style="width: 7px; height: 11px; margin-left: 7px"
                    v-else
                    :src="wqUrl + sortImg[0]"
                    mode=""
                  />
                </div>
              </div>
              <div
                class="list-item"
                v-for="(item, index) in taskList"
                :key="item.id"
                @click="getTaskInfo(1, item)"
              >
                <div class="top">
                  <div class="index">{{ index + 1 }}</div>
                  <div class="title">{{ formatString(item.taskName) }}</div>
                  <div class="accept" @click.stop="getTaskInfo(2, item)">
                    立即接单
                  </div>
                </div>
                <div class="center">
                  <div class="type">
                    {{ item.practiceTypeName }}
                  </div>
                  <div class="region">
                    {{ item.practiceAddres }}
                  </div>
                  <div class="demand">
                    要求 : {{ formatString(item.taskRequire) }}
                  </div>
                  <div class="price">
                    <span class="unit">¥</span> {{ item.taskPrice }}
                  </div>
                </div>
                <div class="bottom">
                  <div class="createTime">{{ item.createTime }}</div>
                </div>
              </div>
            </div>
          </div>

          <div class="empty" v-show="taskList.length == 0">
            <img :src="require('assets/images/kong.png')" alt="" />
            <div>暂无任务</div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="专业服务" name="2">
          <div class="product">
            <div
              class="product_item"
              v-for="(item, index) in dataList"
              :key="index"
              @click="goGoodsDetails(item)"
            >
              <div class="img_box">
                <img :src="item.url || wqUrl + 'wq_service.png'" mode="" />
              </div>
              <div class="product_info">
                <div class="title_box">
                  <div class="title">{{ item.title || item.name }}</div>
                </div>
                <div class="writer_box">
                  <div class="label">
                    {{ item.userName }}
                  </div>
                  <div class="label" @click.stop="show_pop = true">
                    小语AI实验室
                  </div>
                </div>
                <div class="bottom">
                  <div class="price_box">
                    <span class="now_price"
                      ><span style="font-size: 14px">￥</span
                      >{{ item.price }}</span
                    >
                  </div>
                  <div class="score_box">
                    <div
                      style="margin-left: 0"
                      class=""
                      @click.stop="goUserRate(item.id)"
                    >
                      <img
                        style="width: 14px; height: 14px"
                        :src="wqUrl + 'aiExistingWritings_score.png'"
                        mode=""
                      />
                      <span>{{ item.star }}</span>
                    </div>
                    <div class="" @click.stop="commentClick(item)">
                      <img
                        :src="wqUrl + 'aiExistingWritings_comment.png'"
                        mode=""
                      />
                      <span>{{ item.contents || 0 }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </el-tab-pane>
        <el-pagination
          background
          layout="prev, pager, next"
          v-if="activeName == '1'"
          @current-change="paginationClick"
          :total="toatls"
        >
        </el-pagination>
      </el-tabs>
    </div>
    <div class="left" v-if="isInfo == 2">
      <homeDetails @back="isInfo = 1" :dataInfo="dataInfo" />
    </div>
    <div class="left" v-if="isInfo == 3" :class="!ishomeshow ? 'bgc' : ''">
      <purchase @back="back" :serviceId="serviceId" :type="type" />
    </div>
    <div class="left" v-if="isInfo == 4" :class="!ishomeshow ? 'bgc' : ''">
      <userInfoPage @back="back" :infoData="infoData" :type="type" />
    </div>
    <div class="right" :class="!ishomeshow ? 'bgc' : ''">
      <div class="header">
        <div
          class="title"
          @click="!ismore ? (ismore = true) : ''"
          :style="!ismore ? 'cursor: pointer;' : ''"
        >
          <i v-if="!ismore" class="el-icon-arrow-left"></i> 执业榜
        </div>
        <div
          class="more"
          @click="
            ismore = false
            clickSort('comprehensive')
          "
          v-if="ismore"
        >
          更多>>
        </div>
      </div>
      <div
        class="list"
        v-show="Parctlist.length != 0 && ismore"
        @scroll="scrollPractice"
      >
        <div class="list-item" v-for="item in Parctlist" :key="item.id">
          <div class="top">
            <div class="left" @click="ParctlistClick(item)">
              <img :src="item.headImg" alt="" />
            </div>
            <div class="center">
              <div class="center-top">
                <span class="name">{{ item.userName }}</span>
                <div class="mark">
                  <img :src="require('assets/images/star.png')" alt="" />
                  <span class="star">{{ item.star }}</span>
                </div>
              </div>
              <div class="center-bottom">
                {{ item.worksNum }} 作品 | {{ item.praiseNum }} 获赞 |
                {{ item.fansNum }} 粉丝
              </div>
            </div>
            <div class="right">
              <div
                :class="{ followOk: item.attention }"
                class="follow"
                @click="isInterest(item.attention ? 0 : 1, item)"
              >
                {{ item.attention ? '已关注' : '关注' }}
              </div>
            </div>
          </div>
          <div class="bottom">
            <div class="name">{{ item.name }}</div>
            <div class="price"><span class="unit">¥</span>{{ item.price }}</div>
            <div class="salesVolume">已售{{ item.salesVolume }}份</div>
            <div class="buy" @click="goGoodsDetails(item)">购买</div>
          </div>
        </div>
      </div>
      <div class="list" v-show="Parctlist.length != 0 && !ismore">
        <div class="sort_box">
          <div class="" @click="clickSort('comprehensive')">
            <span
              :style="{
                color: sort_xz === 'comprehensive' ? '#f74d47' : '#333',
              }"
              >综合</span
            >
            <img
              v-show="sort_xz !== 'comprehensive'"
              class="downward"
              :src="wqUrl + 'aiExistingWritings_notSort.png'"
              mode=""
            />
            <img
              v-show="sort_xz === 'comprehensive'"
              class="downward"
              :src="wqUrl + 'aiExistingWritings_sort.png'"
              mode=""
            />
          </div>
          <div class="" @click="clickSort('sales_volume')">
            <span
              :style="{
                color: sort_xz === 'sales_volume' ? '#f74d47' : '#333',
              }"
              >销量</span
            >
            <img
              v-show="sort_xz !== 'sales_volume'"
              class="downward"
              :src="wqUrl + 'aiExistingWritings_notSort.png'"
              mode=""
            />
            <img
              v-show="sort_xz === 'sales_volume'"
              class="downward"
              :src="wqUrl + 'aiExistingWritings_sort.png'"
              mode=""
            />
          </div>
          <div class="" @click="clickSort('time')">
            <span :style="{ color: sort_xz === 'time' ? '#f74d47' : '#333' }"
              >时间</span
            >
            <img
              v-show="sort_xz !== 'time'"
              class="downward"
              :src="wqUrl + 'aiExistingWritings_notSort.png'"
              mode=""
            />
            <img
              v-show="sort_xz === 'time'"
              class="downward"
              :src="wqUrl + 'aiExistingWritings_sort.png'"
              mode=""
            />
          </div>
          <div class="" @click="clickSort('good_comment')">
            <span
              :style="{
                color: sort_xz === 'good_comment' ? '#f74d47' : '#333',
              }"
              >好评</span
            >
            <img
              v-show="sort_xz !== 'good_comment'"
              class="downward"
              :src="wqUrl + 'aiExistingWritings_notSort.png'"
              mode=""
            />
            <img
              v-show="sort_xz === 'good_comment'"
              class="downward"
              :src="wqUrl + 'aiExistingWritings_sort.png'"
              mode=""
            />
          </div>
          <div class="" @click="clickSort('pase')">
            <span :style="{ color: sort_xz === 'pase' ? '#326AFB' : '#333' }"
              >价格</span
            >
            <img
              style="width: 7px; height: 11px; margin-left: 7px"
              v-if="sort_xz === 'pase'"
              :src="wqUrl + sortImg[sortData.pase]"
              mode=""
            />
            <img
              style="width: 7px; height: 11px; margin-left: 7px"
              v-else
              :src="wqUrl + sortImg[0]"
              mode=""
            />
          </div>
        </div>
        <div class="list-item" v-for="item in Parctlist" :key="item.id">
          <div class="top">
            <div class="left" @click="ParctlistClick(item)">
              <img :src="item.headImg" alt="" />
            </div>
            <div class="center">
              <div class="center-top">
                <span class="name">{{ item.userName }}</span>
                <div class="mark">
                  <img :src="require('assets/images/star.png')" alt="" />
                  <span class="star">{{ item.star }}</span>
                </div>
              </div>
              <div class="center-bottom">
                {{ item.worksNum }} 作品 | {{ item.praiseNum }} 获赞 |
                {{ item.fansNum }} 粉丝
              </div>
            </div>
            <div class="right">
              <div
                :class="{ followOk: item.attention }"
                class="follow"
                @click="isInterest(item.attention ? 0 : 1, item)"
              >
                {{ item.attention ? '已关注' : '关注' }}
              </div>
            </div>
          </div>
          <div class="bottom">
            <div class="name">{{ item.name }}</div>
            <div class="price"><span class="unit">¥</span>{{ item.price }}</div>
            <div class="salesVolume">已售{{ item.salesVolume }}份</div>
            <div class="buy" @click="goGoodsDetails(item)">购买</div>
          </div>
        </div>
      </div>
      <div class="empty" v-show="Parctlist.length == 0">
        <img :src="require('assets/images/kong.png')" alt="" />
        <div>暂无执业</div>
      </div>
    </div>
    <!-- <div class="right" v-if="ispurchase">
   
    </div> -->
    <el-dialog
      :visible.sync="show_pop"
      mode="center"
      :round="10"
      :safeAreaInsetBottom="false"
      width="30%"
    >
      <div class="xiaoyu_box">
        <img :src="wqUrl + 'aiExistingWritings_xiaoyu.png'" mode="" />
        <div class="title">
          <img :src="wqUrl + 'editedBooks_dialogTip.png'" mode="" />
          小语AI实验室简介
        </div>
        <div class="content">
          小语AI实验室成立于2020年8月，是深圳写手智能科技公司的重要AI研发机构，主要从事垂直细分领域AI语言模型构建与训练、大型语料库建设、多模态AIGC应用等领域研究，致力于为AIGC服务提供核心技术支持。
        </div>
        <div class="btn" @click="show_pop = false">已了解</div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  serviceTaskInfo,
  taskConfirmAccepted,
  receivingOrders,
  clickInterest,
  clickCancelInterest,
  practiceList,
} from 'api/professionServer'
import homeDetails from './components/homeDetails.vue'
import purchase from './components/purchase.vue'
import direction from './components/direction.vue'
import userInfoPage from './components/userInfoPage.vue'
import qs from 'qs'
export default {
  props: ['taskList', 'practiceLists', 'total'],
  components: {
    homeDetails,
    purchase,
    direction,
    userInfoPage,
  },
  created() {
    this.$bus.$on('dataClick', (v) => {
      this.goGoodsDetails(v)
    })

    this.toatls = this.total
    this.Parctlist = this.practiceLists
  },
  watch: {
    practiceLists(val) {
      this.Parctlist = val
    },
    total(v) {
      this.toatls = v
    },
  },
  data() {
    return {
      toatls: 1,
      show_pop: false,
      // 专业服务
      dataList: [],
      activeName: '1',
      // 更多任务
      ismoreRen: true,
      sort_xz: 'comprehensive',
      // 排序的箭头图片
      sortImg: [
        'aigcPage_notSort.png',
        'aigcPage_srotUp.png',
        'aigcPage_srotDown.png',
      ],
      // 更多按钮
      ismore: true,
      Parctlist: [],
      // 1为首页任务版 2为任务详情 3为购买 4为个人中心
      isInfo: 1,
      // 任务详情弹窗
      homeVisible: false,
      // 任务详情
      dataInfo: {},
      type: 2,
      serviceId: '',
      ishomeshow: true,
      infoData: '',
      wqUrl:
        'https://payment-writemall-com.oss-cn-shenzhen.aliyuncs.com/miniapps/wqzk/',
      //排序数据
      sortData: {
        pase: 2,
      },
    }
  },
  methods: {
    paginationClick(i) {
      this.$parent.taskQuery.page = i
      this.$parent.getTaskList()
    },

    handleClick(v) {
      if (v.name == 2) {
        this.practiceList()
      }
      console.log(v)
    },
    async clickSort(el) {
      let sort = ''
      let sortType = 1
      if (el === this.sort_xz) {
        if (this.sortData[el] === 1) {
          this.sortData[el] = 2
        } else {
          this.sortData[el] = 1
        }
      } else {
        this.sort_xz = el
      }
      if (this.sort_xz === 'pase') {
        sort = this.sortData[this.sort_xz] === 2 ? 'DESC' : 'ASC'
      } else {
        sort = 'DESC'
      }
      if (this.sort_xz === 'time') {
        sortType = 1
      } else if (this.sort_xz === 'comprehensive') {
        sortType = 5
      } else if (this.sort_xz === 'sales_volume') {
        sortType = 3
      } else if (this.sort_xz === 'good_comment') {
        sortType = 4
      } else if (this.sort_xz === 'pase') {
        sortType = 2
      }
      let opt = {
        limit: 30,
        page: 1,
        sortType,
        sort,
      }
      this.practiceList(opt)
    },
    async practiceList(opt) {
      let res = await practiceList(qs.stringify(opt))
      if (res.code !== 200) {
        return
      }

      if (opt) {
        this.Parctlist = res.data.data
      } else {
        this.dataList = res.data.data
      }
    },
    // 点击头像
    ParctlistClick(v) {
      this.infoData = v.userId
      this.isInfo = 4
    },
    //, 关注 / 取消关注
    async isInterest(type, item) {
      if (type === 0) {
        this.$confirm('确认是否取消关注', '提示', {
          confirmButtonText: '不再关注',
          cancelButtonText: '再想想',
          type: 'warning',
        })
          .then(async () => {
            let res = await clickCancelInterest(item.userId)
            if (res.code !== 200) return
            this.Parctlist.forEach((el) => {
              if (el.userId === item.userId) {
                el.attention = false
              }
            })
            this.Parctlist = [...this.Parctlist]
            this.$message.success('取消关注成功')
          })
          .catch(() => {})
      } else {
        let res = await clickInterest(item.userId)
        if (res.code !== 200) return
        this.Parctlist.forEach((el) => {
          if (el.userId === item.userId) {
            el.attention = true
          }
        })
        this.Parctlist = [...this.Parctlist]
        this.$message.success('关注成功')
      }
    },
    back() {
      this.isInfo = 1
      this.ishomeshow = true
      this.$parent.ishomeshow = true
    },
    // 点击购买
    goGoodsDetails(v) {
      this.$parent.ishomeshow = false
      this.ishomeshow = false
      this.serviceId = v.id
      this.isInfo = 3
    },
    // 点击接单
    receivingOrders(v) {
      console.log(this.dataInfo)
      let opt = {
        taskId: this.dataInfo.id,
      }
      if (this.dataInfo.isElectronContract) {
        let is = false
        Object.keys(this.partyB).forEach((el) => {
          if (!this.partyB[el]) {
            is = true
          }
        })
        if (is) {
          this.$message.error(
            `请将${this.dataInfo.practiceName}合同信息填写完整`
          )

          return
        }

        if (!this.cascaderXZ.name) {
          this.$message.error(`请选择案由`)

          return
        }

        opt.partyB = {
          ...this.partyB,
          cause: this.cascaderXZ.name,
          mandate: this.radioVal,
        }
      }
      let res
      this.complete = true
      if (this.dataInfo.status === 9) {
        this.$confirm('是否受理该任务', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(async () => {
            res = await taskConfirmAccepted(opt)
            this.complete = false
            if (res.code === 418) {
              this.$message.error(res.data)
              return
            }
            if (res.code !== 200) {
              return
            }
            this.$message.success('受理成功')
            console.log(res)
            // this.getTaskInfo(v.id)
          })
          .catch(() => {})
      } else {
        this.$confirm('是否接单', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(async () => {
            res = await receivingOrders(opt)
            this.complete = false
            if (res.code === 418) {
              this.$message.error(res.data)
              return
            }
            if (res.code !== 200) {
              this.$message.error(res.data)
              return
            }
            this.$confirm('接单成功，是否前往我的任务', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning',
            })
              .then(async () => {
                this.$bus.$emit('goApplyDetails', 'myQuest')
              })
              .catch(() => {
                this.$parent.getTaskList()
              })
          })
          .catch(() => {})
      }
    },
    // 待接单

    async getTaskInfo(id, v) {
      let res = await serviceTaskInfo(v.id)
      if (res.code !== 200) return
      this.dataInfo = res.data
      if (this.dataInfo.practiceAddres) {
        let arr = this.dataInfo.practiceAddres.split('/')
        this.dataInfo.practiceAddres =
          arr[0] == arr[1] ? arr[0] : this.dataInfo.practiceAddres
      }
      if (this.dataInfo.twqReminderAndTaskFeedBack) {
        this.dataInfo.twqReminderAndTaskFeedBack.map((el) => {
          if (el.files) {
            el.files = JSON.parse(el.files)
          }
        })
      }
      if (id == 1) {
        this.isInfo = 2
      } else {
        this.receivingOrders()
      }
    },
    scrollPractice(e) {
      let scrollTop = e.target.scrollTop //滑入屏幕滚动条滚动时，距离顶部的距离
      let windowHeitht = e.target.clientHeight //能看到的页面的高度
      let scrollHeight = e.target.scrollHeight //监控的整个div的高度（包括现在看到的和上下隐藏起来看不到的）
      let total = scrollTop + windowHeitht
      this.$parent.loddingVisible = true
      if (total == scrollHeight) {
        this.$parent.practiceQuery.page++
        this.$parent.getPracticeList()
      }
    },
    formatString(str) {
      if (str.length >= 35) {
        return str.substring(0, 36) + '......'
      } else {
        return str
      }
    },
    scrollTask(e) {
      let scrollTop = e.target.scrollTop //滑入屏幕滚动条滚动时，距离顶部的距离
      let windowHeitht = e.target.clientHeight //能看到的页面的高度
      let scrollHeight = e.target.scrollHeight //监控的整个div的高度（包括现在看到的和上下隐藏起来看不到的）
      let total = scrollTop + windowHeitht
      this.$parent.loddingVisible = true
      if (total == scrollHeight) {
        this.$parent.taskQuery.page++
        this.$parent.getTaskList()
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.list-content {
  width: 1130px;
  display: flex;
  position: relative;
  align-items: flex-start;
  justify-content: space-between;
  margin: 0 auto 20px;
  > .left {
    width: 707px;
    height: 1360px;
    background: #fff;
    padding: 15px 20px;
    box-sizing: border-box;
    border-radius: 10px;
    .product {
      height: 1260px;
      overflow-y: auto;
      padding: 10px;
      box-sizing: border-box;
    }
    .products {
      height: 1260px;
      overflow-y: auto;
    }
    .product_item {
      display: flex;
      padding: 12px 0;
      padding: 10px;
      box-sizing: border-box;
      &:hover {
        border-radius: 4px;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1), 0 0 6px rgba(0, 0, 0, 0.2);
      }

      .img_box {
        width: 100px;
        height: 100px;
        background: #ccc;
        border-radius: 10px;
        margin-right: 15px;
        overflow: hidden;

        > img {
          width: 100%;
          height: 100%;
        }
      }

      .product_info {
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: center;

        .title_box {
          display: flex;
          align-items: center;
          justify-content: space-between;

          .title {
            cursor: pointer;
            max-width: 175px;
            font-size: 17px;
            color: #333;
            font-weight: bold;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }

          .collect_box {
            > img {
              width: 15px;
              height: 15px;
              vertical-align: middle;
            }
          }
        }

        .writer_box {
          display: flex;
          margin-top: 10px;

          .label {
            cursor: pointer;
            height: 19px;
            line-height: 19px;
            padding: 0 6px;
            background: #f7f7f7;
            border-radius: 3px;
            font-size: 11px;
            color: #999;
            margin-right: 10px;
          }
        }

        .bottom {
          display: flex;
          // align-items: center;
          justify-content: space-between;
          margin-top: 20px;

          .price_box {
            .now_price {
              color: #f52c26;
              font-size: 20px;
              margin-right: 9px;
            }
          }

          .score_box {
            display: flex;
            align-items: center;

            > div {
              margin-left: 15px;
              min-width: 40px;

              > img {
                width: 12px;
                height: 12px;
                vertical-align: middle;
                margin-top: -2px;
                margin-right: 5px;
              }

              > span {
                font-size: 13px;
                color: #999;
              }
            }
          }
        }
      }
    }
    .header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: 30px;
      .title {
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #333333;
      }
      .more {
        cursor: pointer;
        font-size: 12px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #999999;
        cursor: pointer;
      }
    }
    .list {
      height: calc(100% - 30px);
      overflow: auto;
      padding: 0 10px;
      box-sizing: border-box;

      .list-item {
        display: flex;
        cursor: pointer;
        flex-direction: column;
        gap: 15px;
        margin-bottom: 10px;
        border-bottom: 1px solid #f7f7f7;
        padding: 10px;
        &:hover {
          border-radius: 4px;
          box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1), 0 0 6px rgba(0, 0, 0, 0.2);
        }
        .top {
          display: flex;
          align-items: center;
          .index {
            width: 24px;
            height: 24px;
            margin-right: 10px;
            background: #f2f6ff;
            border-radius: 50%;
            font-size: 16px;
            font-family: PingFang SC;
            font-weight: bold;
            color: #326afb;
            // line-height: 15px;
            display: flex;
            align-items: center;
            justify-content: center;
          }
          .title {
            font-size: 16px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #222222;
            flex: 1;
          }
          .accept {
            width: 79px;
            height: 28px;
            background: #f4f7ff;
            border-radius: 5px;
            font-size: 16px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #326afb;
            line-height: 28px;
            text-align: center;
            font-size: 14px;
            box-sizing: border-box;
            cursor: pointer;
            position: relative;
            // &::after {
            //   content: "";
            //   position: absolute;
            //   width: 7px;
            //   height: 7px;
            //   border-radius: 50%;
            //   background: #326afb;
            //   top: 50%;
            //   transform: translateY(-50%);
            //   left: 8px;
            // }
          }
        }
        .center {
          display: flex;
          align-items: center;
          .type,
          .region {
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #999999;
          }
          .region {
            margin-left: 10px;
          }
          .demand {
            margin-left: 20px;
            flex: 1;
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #333333;
            line-height: 15px;
            // text-align: center;
          }
          .price {
            .unit {
              font-size: 12px;
            }
            font-size: 18px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #ff5346;
            line-height: 15px;
          }
        }
        .bottom {
          .createTime {
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #999999;
          }
        }
      }
    }
    .empty {
      text-align: center;
      margin: 25% 0;
      img {
        width: 150px;
        height: 150px;
      }
      font-size: 14px;
      color: #999;
      text-align: center;
    }
  }
  .bgc {
    height: 730px !important;
  }
  > .right {
    width: 404px;
    height: 1360px;
    background: #fff;
    padding: 15px 20px;
    box-sizing: border-box;
    border-radius: 10px;
    .header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: 30px;
      .title {
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #333333;
      }
      .more {
        cursor: pointer;
        font-size: 12px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #999999;
        cursor: pointer;
      }
    }
    .list {
      height: calc(100% - 30px);
      overflow: auto;
      .sort_box {
        margin: 10px 0;
        width: 100%;
        box-sizing: border-box;
        background-color: #fff;
        display: flex;
        align-items: center;
        color: #333;
        margin: 15px 0 5rpx;
        justify-content: space-between;

        > div {
          cursor: pointer;
          display: flex;
          align-items: center;
          font-size: 14px;
        }

        .downward {
          width: 12px;
          height: 12px;
          margin-left: 8px;
        }
      }
      .list-item {
        margin-top: 15px;
        .top {
          display: flex;
          align-items: center;
          justify-content: space-between;
          .left {
            width: 64px;
            height: 64px;
            > img {
              width: 100%;
              height: 100%;
              border-radius: 50%;
            }
          }
          .center {
            flex: 1;
            margin-left: 20px;
            display: flex;
            flex-direction: column;
            gap: 10px;

            .center-top {
              display: flex;
              align-items: center;
              // justify-content: space-evenly;
              gap: 10px;
              .name {
                font-size: 16px;
                font-family: Microsoft YaHei;
                font-weight: 400;
                color: #f63c3d;
              }
              .mark {
                display: flex;
                align-items: center;
                gap: 5px;
                img {
                  width: 13px;
                  height: 13px;
                }
                .star {
                  font-family: Adobe Heiti Std;
                  font-weight: normal;
                  font-style: italic;
                  color: #f6b529;
                }
              }
            }
            .center-bottom {
              font-size: 14px;
              font-family: Microsoft YaHei;
              font-weight: 400;
              color: #a5a8b0;
            }
          }
          .right {
            .follow {
              width: 54px;
              height: 25px;

              background: #ebf1ff;
              border-radius: 12px;
              font-size: 14px;
              font-family: Microsoft YaHei;
              font-weight: 400;
              color: #326afb;
              display: flex;
              align-items: center;
              justify-content: center;
              cursor: pointer;
            }
            .followOk {
              color: #868686;
              background: #f1f1f1;
            }
          }
        }
        .bottom {
          display: flex;
          align-items: center;
          margin-top: 10px;
          .name {
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #333333;
            width: 50%;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
          .price {
            flex: 1;
            font-size: 16px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #ff5346;
            .unit {
              font-size: 12px;
            }
          }
          .salesVolume {
            flex: 1;
            font-size: 12px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #a5a8b0;
          }
          .buy {
            // flex: 1;
            width: 54px;
            height: 25px;
            background: #ff5346;
            border-radius: 12px;
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #ffffff;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
          }
        }
      }
    }
    .empty {
      text-align: center;
      margin: 25% 0;
      img {
        width: 150px;
        height: 150px;
      }
      font-size: 14px;
      color: #999;
      text-align: center;
    }
  }
}
.sort_box1 {
  margin: 10px 0;
  width: 100%;
  box-sizing: border-box;
  background-color: #fff;
  display: flex;
  align-items: center;
  color: #333;
  margin: 15px 0 5rpx;
  > div {
    cursor: pointer;
    display: flex;
    align-items: center;
    font-size: 14px;
    margin-right: 20px;
  }

  .downward {
    width: 12px;
    height: 12px;
    margin-left: 8px;
  }
}
.xiaoyu_box {
  position: relative;
  width: 100%;

  > img {
    width: 114px;
    height: 103px;
    position: absolute;
    top: 25px;
    right: 10px;
  }

  .title {
    cursor: pointer;
    padding: 28px 0 0 28px;
    box-sizing: border-box;
    font-size: 17px;
    color: #333;
    font-weight: bold;

    > img {
      width: 20px;
      height: 20px;
      vertical-align: middle;
      margin-top: -2px;
      margin-right: 10px;
    }
  }

  .content {
    margin-top: 40px;
    padding: 0 45px;
    font-size: 14px;
    color: #333;
    line-height: 28px;
  }

  .btn {
    cursor: pointer;
    margin-top: 30px;
    margin-bottom: 25px;
    text-align: center;
    font-size: 16px;
    color: #326afb;
  }
}
::v-deep .el-tabs__header {
  border-bottom: 2px solid #326afb !important;
  height: 32px;
  .el-tabs__nav {
    border: none !important;
    border-bottom: 1px solid #326afb !important;

    .el-tabs__item {
      border: none !important;
      height: 32px;
      line-height: 34px;
    }
    .is-active {
      color: #fff;
      font-weight: 600;
      background-color: #326afb;
      border-radius: 2px 2px 0 0;
    }
  }
}
</style>
